export const getVector = (name)=> `${distLocation}/vector/${name}.svg`;
export const range = (start, end) =>{
    return Array((end) - (start) + 1).fill().map((_, idx) => start + idx)
}

export const validateEmail = (email)  =>{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
